var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "spnod-admin__form--main d-flex align-items-center flex-column",
    attrs: {
      "id": "login-main"
    }
  }, [_c('h3', {
    staticClass: "h3 mb-4"
  }, [_vm._v("Order Failure")]), _vm._v(" "), _c('p', {
    staticClass: "text-center mb-5"
  }, [_vm._v("We are unable to process your payment at this time. Please contact your payment service provider for more information.")]), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.tryAgain()
      }
    }
  }, [_vm._v("Try Again")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0627c4b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AdminAuth/PaymentFailure.vue
// module id = 3grb
// module chunks = 2